import Page from "@/components/layout/Page";

export default function ParentsCarers() {
  return (
    <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
      <Page>
        <section className="w-full pb-24">
          <div className="max-w-[1280px] mx-auto px-6">
          <h1 className="text-[54px] leading-[1.1] font-bold mb-6 page-title-gradient">Parents & Carers</h1>
          
          <div className="space-y-6 max-w-3xl">
            <p className="text-xl text-muted-foreground leading-relaxed">
              Support your family with sensory tools designed for home use and daily routines.
            </p>
            
            <p className="text-lg leading-relaxed">
              Samboards understands the daily challenges parents and carers face when supporting children and family members with additional sensory needs. Our products provide practical, portable solutions for managing anxiety, supporting focus, and promoting calm at home and on the go.
            </p>
            
            <p className="text-lg leading-relaxed">
              Whether you're managing homework time with a child who has ADHD, supporting a family member with autism through transitions, or helping someone with dementia feel calm and engaged, our sensory tools offer gentle, non-intrusive support that fits into everyday life.
            </p>
            
            <p className="text-lg leading-relaxed">
              Parents love that our products are durable, washable, and portable - perfect for car journeys, waiting rooms, restaurants, or any situation where a calming sensory tool might be needed. They're also quiet, making them ideal for use in public spaces without drawing unwanted attention.
            </p>
            
            <p className="text-lg leading-relaxed">
              Many families find that having sensory tools readily available helps prevent meltdowns, supports emotional regulation, and gives their loved ones a healthy way to self-soothe during challenging moments.
            </p>
          </div>
        </div>
      </section>
      </Page>
    </div>
  );
}
